<div class="child-contact-info">
  <div *ngIf="ready" role="content" class="child-contact-info-content">
    <se-po-add-child-contact-info #childContactInfo
      *ngIf="ready"
      [persona]="persona"
      [description]="description"
    ></se-po-add-child-contact-info>
    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="submit"
        [seFeDataFullWidth]="true"
        (click)="submit()"
      >Continue</se-fe-button>
    </div>
  </div>
</div>
